export const MISSING_PROVIDER =
  'AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.';

export const UNSUPPORTED_ENV = (fnName: string) =>
  `UserManager#${fnName} was called from an unsupported context.`;

export const INVALID_URL =
  'Invalid return url. The return url needs to have the same origin as the current page.';
